var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMaximize = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2C2.22876 2 1.33333 2.89543 1.33333 4V12C1.33333 13.1046 2.22876 14 3.33333 14H12.6667C13.7712 14 14.6667 13.1046 14.6667 12V4C14.6667 2.89543 13.7712 2 12.6667 2H3.33333ZM6.89952 10.5824C6.67855 10.8069 6.29974 10.8069 6.07351 10.5771C5.84727 10.3472 5.84201 9.95692 6.06298 9.73239L9.94244 5.79036L10.7632 5.02053L10.0371 5.04191L8.38512 5.09537C8.22728 5.10607 8.06945 5.03122 7.96948 4.92965C7.74851 4.70511 7.74851 4.38435 7.96422 4.16516C8.07471 4.05289 8.20624 4.01547 8.36407 4.01547L11.8575 4.07962C12.068 4.07962 12.1942 4.13308 12.3047 4.24535C12.4099 4.35227 12.4626 4.48058 12.4626 4.69442L12.5257 8.24421C12.5257 8.40459 12.4889 8.53824 12.3784 8.65051C12.1627 8.8697 11.8365 8.85901 11.6208 8.63982C11.5208 8.53824 11.4524 8.38321 11.4629 8.22283L11.5155 6.54416L11.5366 5.8064L10.779 6.64039L6.89952 10.5824Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMaximize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-maximize.8ebd13c87170e1c57d24cdc6550c059a.svg";